<template>
    <button
        type="button"
        aria-label="открыть видео"
        :class="sizeByColumn"
        class="group relative aspect-video shrink-0 rounded-20"
        @click="handleOpenVideo">
        <picture class="object-cover">
            <source
                v-if="imageWebp"
                type="image/webp"
                :srcset="imageWebp" />

            <source
                v-else-if="!imageWebp && !image"
                type="image/webp"
                srcset="/assets/images/ui/placeholder/webp/cromi.webp" />

            <img
                width="785"
                height="400"
                :alt="`Превью видео ${title}` || 'Превью видео'"
                :src="
                    image || '/assets/images/ui/placeholder/jpg-png/cromi.png'
                "
                :loading="disableLoadingLazy ? 'eager' : 'lazy'"
                class="aspect-video h-full w-full rounded-8 object-cover xl:rounded-12" />
        </picture>
        <span
            v-if="title"
            v-html="title"
            :class="[titleClasses]"
            class="absolute inline-block text-16/120 font-semibold text-ash-200" />
        <span
            v-if="duration"
            v-html="duration"
            :class="
                size === 'medium' || size === 'large'
                    ? 'bottom-2 right-2 md:bottom-1 md:right-1'
                    : 'bottom-2 right-2'
            "
            class="absolute rounded-4 bg-black/50 px-2 py-1 text-14/148 text-ash-200 xl:rounded-8 xl:p-2.5 xl:text-16/120" />
        <PlaySvg
            :class="
                size === 'medium' || size === 'large'
                    ? 'size-[3.75rem]'
                    : 'size-[5.375rem]'
            "
            class="absolute inset-1/2 -translate-x-1/2 -translate-y-1/2 text-accent opacity-25 group-hover:opacity-100" />
    </button>
</template>

<script setup lang="ts">
import PlaySvg from '~/components/base/base-video/PlaySvg.vue'

const props = defineProps({
    size: {
        type: String as PropType<'medium' | 'large' | 'big'>,
        default: 'medium',
    },
    image: {
        type: String as PropType<string>,
        default: null,
    },
    imageWebp: {
        type: String as PropType<string>,
        default: null,
    },
    duration: {
        type: String as PropType<string>,
        default: null,
    },
    title: {
        type: String as PropType<string>,
        default: null,
    },
    url: {
        type: String as PropType<string>,
        default: null,
    },
    disableLoadingLazy: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
    disableTitleClamp: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
    inColumn: {
        type: Number as PropType<number>,
        default: 3,
    },
})

const modalStore = useModalStore()

const sizeByColumn = computed(() => {
    if (props.size === 'large') {
        return 'w-full lg:w-[16.25rem]'
    }

    if (props.inColumn >= 3) {
        return props.size === 'medium'
            ? 'w-full lg:w-[10rem] xl:w-[15.46rem]'
            : 'w-full md:w-2/3 lg:w-[33.5rem] xl:w-[49.125rem]'
    } else {
        return props.size === 'medium'
            ? 'w-full lg:w-[15rem] lg:h-[9rem] xl:w-[16.25rem] xl:h-[11.875rem]'
            : 'w-full md:w-2/3 lg:w-[33.5rem] xl:w-[49.125rem] xl:h-[25rem]'
    }
})

const titleClasses = computed(() => {
    if (props.size === 'large') {
        return 'bg-video-title p-2.5 text-20/120 max-md:bottom-0 max-md:left-0 max-md:rounded-bl-8 max-md:rounded-tr-8 md:left-0 md:top-0 md:rounded-br-8 md:rounded-tl-8 md:p-2 md:text-16/120 xl:rounded-br-12 xl:rounded-tl-12 xl:px-4 xl:py-3 xl:text-20/120 xl:tracking-[-0.075rem]'
    }

    if (props.inColumn >= 3) {
        return props.size === 'medium'
            ? 'bg-video-title p-2.5 text-20/120 max-md:bottom-0 max-md:left-0 max-md:rounded-bl-8 max-md:rounded-tr-8 md:left-0 md:top-0 md:rounded-br-8 md:rounded-tl-8 md:p-2 md:text-16/120 xl:rounded-br-12 xl:rounded-tl-12 xl:px-4 xl:py-3 xl:text-20/120 xl:tracking-[-0.075rem]'
            : 'bg-video-title bottom-0 left-0 rounded-bl-8 rounded-tr-8 p-2.5 text-20/120 lg:p-4 xl:rounded-bl-12 xl:rounded-tr-12 xl:px-8 xl:py-6 xl:text-48/100 xl:tracking-[-0.15rem]'
    } else {
        return props.size === 'medium'
            ? 'bg-video-title text-left md:w-full p-2.5 md:text-20/120 max-md:rounded-tl-8 max-md:rounded-br-8 left-0 top-0 md:rounded-t-8 md:p-2 md:text-16/120 xl:rounded-t-12 xl:px-4 xl:py-3 xl:text-24/100 xl:tracking-[-0.075rem]'
            : 'md:bottom-0 max-md:top-0 left-0 max-md:rounded-tl-8 max-md:rounded-br-8 md:rounded-bl-8 md:rounded-tr-8 bg-video-title p-2.5 md:text-20/120 lg:p-4 xl:rounded-bl-12 xl:rounded-tr-12 xl:px-8 xl:py-6 xl:text-48/100 xl:tracking-[-0.15rem]'
    }
})

function handleOpenVideo() {
    modalStore.setVideoLink(props.url)
    modalStore.open('video')
}
</script>
